import { render, staticRenderFns } from "./InCurand.vue?vue&type=template&id=31d19be3"
import script from "./InCurand.vue?vue&type=script&lang=js"
export * from "./InCurand.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports